import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const BannerSection: React.FC = () => {
  const [currentText, setCurrentText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  
  const typingSpeed = 100;
  const deletingSpeed = 50;
  const pauseTime = 2000;

  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes blink {
        0%, 50% { opacity: 1; }
        51%, 100% { opacity: 0; }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    const texts = ["your hobby", "your future", "your health"];
    const timeout = setTimeout(() => {
      const current = texts[currentIndex];
      
      if (isDeleting) {
        setCurrentText(current.substring(0, currentText.length - 1));
      } else {
        setCurrentText(current.substring(0, currentText.length + 1));
      }

      if (!isDeleting && currentText === current) {
        setTimeout(() => setIsDeleting(true), pauseTime);
      } else if (isDeleting && currentText === "") {
        setIsDeleting(false);
        setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
      }
    }, isDeleting ? deletingSpeed : typingSpeed);

    return () => clearTimeout(timeout);
  }, [currentText, currentIndex, isDeleting, typingSpeed, deletingSpeed, pauseTime]);

  return (
    <section className="elementor-section elementor-top-section elementor-element elementor-element-a3ad65d elementor-section-content-middle scheme_dark elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
      <div className="elementor-background-overlay"></div>
      <div className="elementor-container elementor-column-gap-extended">
        <div className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-8f909f2 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-element elementor-element-dc72754 sc_height_large sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
            <div className="elementor-element elementor-element-fc39f35 sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-container">
                <div className="sc_title sc_title_default">
                  <h2 className="sc_item_title sc_title_title sc_item_title_style_default sc_typed">
                    <span className="sc_item_title_text">
                      We create innovation <br />
                      for <u>
                        <span className="sc_typed_entry trx_addons_inline_2126954918 sc_typed_inited" 
                              style={{ minHeight: '1.2em', display: 'inline-block' }}>
                          {currentText}
                          <span className="cursor" style={{ 
                            animation: 'blink 1s infinite',
                            marginLeft: '2px'
                          }}>|</span>
                        </span>
                      </u>.
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <div className="elementor-element elementor-element-74c73a3 sc_height_large sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-261ff50 sc_layouts_column_align_right sc_layouts_column sc-mobile_layouts_column_align_left sc_layouts_column sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-element elementor-element-cd88374 sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
            <div className="elementor-element elementor-element-407c43c sc_height_huge sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
            <div className="elementor-element elementor-element-4af36a3 sc_height_small sc_layouts_hide_on_wide sc_layouts_hide_on_desktop sc_layouts_hide_on_notebook sc_layouts_hide_on_tablet sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
            <div className="elementor-element elementor-element-293d6cd sc_fly_static elementor-widget elementor-widget-trx_sc_button trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited">
              <div className="elementor-widget-container">
                <div className="sc_item_button sc_button_wrap">
                  <Link
                    to="/about-us"
                    className="sc_button sc_button_default sc_button_size_normal sc_button_icon_left"
                  >
                    <span className="sc_button_text">
                      <span className="sc_button_title">About Us</span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerSection;
